import React from 'react';
import Main from '../../organisms/Main/Main';

function Sale() {
	return <Main title='Wyprzedaż' status='wyprzedaz' />;
}

export default Sale;
